export default {
    "/": {
        "title": "Taoify - แพลตฟอร์มสร้างเว็บไซต์อีคอมเมิร์ซข้ามประเทศ | สินค้าจากจีน ขายทั่วโลก",
        "desc": "Taoify รวบรวมการสร้างเว็บไซต์, การแปล, การลงสินค้า, โลจิสติกส์, การชำระเงิน, และการตลาดไว้ในหน้าเดียว: 18 ผู้ช่วย AI ทำงานให้คุณ, เปิดร้านค้าได้ใน 20 ภาษา, ขายสินค้าจากจีนไปทั่วโลก."
    },
    "/feature": {
        "title": "ฟังก์ชัน · ทุกอย่างที่ต้องใช้ในการเปิดร้านค้า มีครบในหน้านี้ · Taoify",
        "desc": "สร้างเว็บไซต์, การแปล, การลงสินค้า, การส่งสินค้า, การชำระเงิน, การดึงดูดลูกค้า — Taoify รวม 15 โมดูลที่จำเป็นสำหรับการขายข้ามประเทศไว้ในหน้าเดียว ไม่ต้องไปหาเครื่องมือหลาย ๆ ตัวจากที่อื่น."
    },
    "/ai-staff": {
        "title": "พนักงาน AI · 18 ผู้ช่วย AI ที่ทำงานหนักที่สุดคือกลุ่มดึงดูดทราฟฟิก · Taoify",
        "desc": "ใน 18 ผู้ช่วย AI นั้น, 5 ผู้ช่วยของทีมการเติบโตจะเน้นแก้ปัญหา 'ไม่มีคนมา' ด้วย 12 รายการตรวจสอบร้านค้า, แผนการตลาด 30 วัน, ปรับแต่งสินค้าเดียวให้เข้ากับ 9 ช่องทาง, และอีเมลการตลาดอัตโนมัติเพื่อดึงดูดลูกค้าเก่ากลับมา."
    },
    "/logistics": {
        "title": "โลจิสติกส์ข้ามประเทศ · จากมือคุณถึงมือลูกค้า · Taoify",
        "desc": "ขนส่งแรก, ผ่านศุลกากร, ขนส่งหลัก, และการส่งมอบปลายทาง, เลือกเส้นทางตามสินค้าและเวลาที่ต้องการ. ยานยนต์, Yanwen, และ 4PX ได้เชื่อมต่อแล้ว, ใบส่งสินค้า, สถานะการขนส่ง, และการจัดการปัญหาทั้งหมดอยู่ในหน้าเดียว."
    },
    "/payment": {
        "title": "การชำระเงินและการโอนเงิน · ลูกค้าสามารถชำระเงินได้อย่างสะดวก · Taoify",
        "desc": "PayPal, Stripe, บัตรเครดิต, และ Alipay พร้อมใช้งาน. รับชำระเป็นสกุลเงินต่างประเทศ, ถอนเป็นเงินหยวน, ชำระเงิน T+7, อัตราค่าธรรมเนียมและเวลาการโอนเงินระบุไว้อย่างชัดเจน."
    },
    "/pricing": {
        "title": "ราคา · แพ็คเกจสมัครสมาชิก + ค่าคอมมิชชันแบบขั้นบันได · Taoify",
        "desc": "ค่าใช้จ่ายของร้านค้าตามแพ็คเกจสมัครสมาชิก: รุ่นพื้นฐาน $15/เดือน, รุ่นมาตรฐาน $29/เดือน, รุ่นพรีเมียม $59/เดือน, ประหยัดมากขึ้นเมื่อชำระรายไตรมาสหรือรายปี. ค่าคอมมิชชันจากการขายตามยอดขายรายเดือน, ต่ำสุด 3%."
    },
    "/cases": {
        "title": "กรณีศึกษาผู้ขาย · พวกเขาทำสิ่งเดียวกัน · Taoify",
        "desc": "ของแต่งจากยี่ห้อ, อุปกรณ์อิเล็กทรอนิกส์จากเซินเจิ้น, แฟชั่นจากกวางโจว รวมถึงผู้ขายจากเยอรมนี, สหรัฐอเมริกา, และฝรั่งเศส — หกคน, หกจุดเริ่มต้น, แนวทางเดียว."
    },
    "/sign-up": {
        "title": "เปิดร้านค้า - ลงทะเบียนฟรีกับ Taoify",
        "desc": "สร้างเว็บไซต์แบรนด์ของคุณภายใน 10 นาที ไม่จำเป็นต้องเขียนโค้ด ทดลองใช้งานฟังก์ชันทั้งหมดในแพ็คเกจสมัครสมาชิก วงจรป้อนกลับครบวงจร. ลงทะเบียนกับ Taoify ตอนนี้ เพื่อเริ่มต้นการขายข้ามพรมแดน."
    },
    "/for-china-sellers": {
        "title": "สำหรับผู้ขายชาวจีน · คุณแค่เลือกสินค้าและกำหนดราคา เราจะดูแลทุกอย่าง · Taoify",
        "desc": "สร้างเว็บไซต์, การแปล, ค่าขนส่ง, พิมพ์ใบส่งของ, ตอบคำถามลูกค้า — ความยุ่งยากเหล่านี้ระหว่างการขายข้ามพรมแดน แพลตฟอร์มของเราจะดูแลให้. สมัครสมาชิก + ค่าคอมมิชชั่นแบบขั้นบันได (ต่ำสุด 3%)."
    },
    "/for-global-sellers": {
        "title": "สำหรับผู้ขายต่างชาติ: เลือกสินค้าจากชั้นวางของจีน แล้วขายในร้านของคุณเอง · Taoify",
        "desc": "ไม่ต้องสต็อกสินค้า: เลือกสินค้าจากซัพพลายเชนจีน หลังจากลูกค้าสั่งซื้อ ของจะถูกส่งตรงจากคลังสินค้าในจีน คุณทำกำไรจากการต่างราคา. BuyLink ยังสามารถเปลี่ยนลิงก์ 1688 และ Taobao เป็นสินค้าของคุณได้."
    },
    "/template-index": {
        "title": "ตลาดเทมเพลต - เทมเพลตธีมเว็บไซต์มืออาชีพจาก Taoify",
        "desc": "เทมเพลตธีมเว็บไซต์มืออาชีพสำหรับโครงการใดๆ ใช้งานเทมเพลตอุตสาหกรรมมากมายได้ฟรี ปรับแต่งภาพลักษณ์และฟังก์ชันของแบรนด์ตามความต้องการ."
    },
    "/question": {
        "title": "ศูนย์ช่วยเหลือ · มีปัญหา ลองค้นหาที่นี่ก่อน · Taoify",
        "desc": "เปิดร้าน, ตกแต่ง, ลงสินค้า, จัดการคำสั่งซื้อและการจัดส่ง, การชำระเงิน, การตลาด, การจัดการสิทธิ์บัญชี — คำถามที่พบบ่อยจัดหมวดหมู่ไว้แล้ว หาไม่เจอให้ส่งตั๋วสนับสนุน."
    },
    "/about-us": {
        "title": "เกี่ยวกับ Taoify · เราทำอะไร",
        "desc": "Taoify คือแพลตฟอร์มสร้างเว็บไซต์แบบครบวงจรสำหรับผู้ขายข้ามพรมแดน: สร้างเว็บไซต์, แปลภาษา, ลงสินค้า, จัดการโลจิสติกส์, การชำระเงิน, และการตลาด สามารถทำได้ทั้งหมดในหน้าเดียว"
    },
    "/privacy-policy": {
        "title": "นโยบายความเป็นส่วนตัว · Taoify",
        "desc": "Taoify รวบรวม ใช้ จัดเก็บ และปกป้องข้อมูลส่วนบุคคลของคุณอย่างไร รวมถึงสิทธิ์ที่คุณมีต่อข้อมูลของตนเอง"
    },
    "/terms-service": {
        "title": "ข้อกำหนดการให้บริการ · Taoify",
        "desc": "ข้อกำหนดและเงื่อนไขในการใช้บริการบนแพลตฟอร์ม Taoify: บัญชี, ร้านค้า, สั่งซื้อ, การชำระเงิน และการแบ่งแยกความรับผิดชอบ"
    },
    "/consumer-agreement": {
        "title": "นโยบายการคืนเงิน · Taoify",
        "desc": "กฎเกณฑ์การคืนเงินและบริการหลังการขายสำหรับคำสั่งซื้อบนแพลตฟอร์ม Taoify: เงื่อนไขการขอคืนเงิน, ระยะเวลาในการดำเนินการ, และวิธีการรับเงินคืน"
    },
    "/user-agreement": {
        "title": "ข้อตกลงผู้ใช้ · Taoify",
        "desc": "กรุณาอ่าน: ข้อกำหนดการลงทะเบียนบัญชี, กฎระเบียบในการดำเนินธุรกิจ, และคำอธิบายบริการแพลตฟอร์มก่อนที่จะลงทะเบียนและใช้งาน Taoify"
    }
}
